package com.dotdrives.web.ui

import react.FC
import react.Props
import react.dom.html.ReactHTML.span
import web.cssom.ClassName

external interface DotAvatarProps : Props {
    var decorative: Boolean?
    var initials: String
    var size: Int?
    var className: String?
}

val DotAvatar = FC<DotAvatarProps> { props ->
    val size = props.size ?: 40
    val initials = props.initials.trim().take(3).uppercase()
    val avatarStyle = js("({})")
    avatarStyle.width = "${size}px"
    avatarStyle.height = "${size}px"
    avatarStyle.fontSize = "${size * 0.32}px"

    span {
        className = ClassName(listOfNotNull("dot-avatar", props.className).joinToString(" "))
        style = avatarStyle
        if (props.decorative == true) ariaHidden = true
        else {
            role = "img".unsafeCast<react.dom.aria.AriaRole>()
            ariaLabel = "$initials avatar"
        }
        +initials
    }
}

/** Keep brand tints; use the readable foreground for small initials. */
fun accessibleAvatarText(color: String): String =
    if (color == com.dotdrives.design.DotColors.PRIMARY_TINT_TEXT) "var(--dot-action-text)" else color
